import { render } from "./login_box.vue?vue&type=template&id=16b2b6f6&scoped=true"
import script from "./login_box.vue?vue&type=script&lang=js"
export * from "./login_box.vue?vue&type=script&lang=js"

import "./login_box.vue?vue&type=style&index=0&id=16b2b6f6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-16b2b6f6"

export default script